<div class="offer-order">
  @if (constructionTypes && !contactToDisplay?.Anonymized && userId === selectedLeadDetails?.Editor?.Id) {
    <button class="edit-btn" (click)="onOfferOrderEdit()">
      <img src="assets/icons/pencil.svg" alt="Edit" #edit  [isTitle]="true"
        fiTranslation="ALT_TEXT_REQUEST_LIST_EDIT" matTooltip="{{edit.dataset.matTooltip}}"
        matTooltipPosition="below" matTooltipClass='tooltip-style'>
    </button>
  }

  <div class="order-column">
    <span class="title" fiTranslation="ALT_TEXT_REQUEST_TYPE_OFFER"></span>

    @if (mainOffer?.Amount !== null && mainOffer?.Amount !== undefined) {
      <div class="amount">{{offerAmountCount | appCurrency: mainOffer?.CurrencyCode}}</div>
    }
    @if (mainOffer?.Amount === null || mainOffer?.Amount === undefined) {
      <div class="amount" fiTranslation="REQUEST_DETAIL_HEADER_MENU_OFFER_EMPTY_HEADLINE"></div>
    }
  </div>

  <div class="order-column">
    <span class="title" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER"></span>

    @if (mainOrder?.Amount !== null && mainOrder?.Amount !== undefined) {
      <div class="amount">{{orderAmountCount | appCurrency: mainOrder?.CurrencyCode}}</div>
    }
    @if (mainOrder?.Amount === null || mainOrder?.Amount === undefined) {
      <div class="amount" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_HEADLINE"></div>
    }
  </div>

</div>
